module.exports = __webpack_public_path__ + "img/ignis-glx-duna.867e6cbc.png";